<template>
    <div :class="formGroup" class="is-select">
        <label :for="getFieldId" v-if="label" v-text="__(label)"></label>
        <select :value="value"
                :name="name"
                :id="getFieldId"
                :required="required"
                :readonly="readonly"
                :disabled="disabled"
                class="form-control"
                :class="classControl"
                @change="updateValue($event.target.value, 'change')"
                @input="updateValue($event.target.value, 'input')">
            <option v-if="label" value="">{{ __('Select :label', {label: label}) }}...</option>
            <slot></slot>
        </select>
    </div>
</template>

<script>

    let InputField = require('@/mixins/InputField');

    export default {
        mixins: [InputField],
    }
</script>
